import React from "react";
import { Card } from "react-bootstrap";

const CompanyDetails = ({ title, data, tooltips = {} }) => {
  const hasData =
    data &&
    Object.values(data).some(
      (val) => val !== undefined && val !== null && val !== ""
    );

  if (!hasData) return null;

  return (
    <Card className="p-4 h-100">
      <h3 className="mb-3">{title}</h3>
      <ul className="personal-info">
        {Object.entries(data).map(([label, value]) => {
          if (!value) return null;
          return (
            <li key={label}>
              <div className="title company-label" title={tooltips[label]}>
                {label}
              </div>
              <div className="text">{value}</div>
            </li>
          );
        })}
      </ul>
    </Card>
  );
};

export default CompanyDetails;
